import React from 'react';
import { useBookingEditText } from "../text";
import Dropdown from '../../../../components/ui/Dropdown';
import { cn } from '../../../../utils/classnames';
import { createTypographyHelper } from '../../../../utils/typography';
// import PaxIcon from '../../../../icons/form-icons/pax.svg';
import { PaxIcon } from '../../../icons';

const PassengerDropdown = ({ passengers, setPassengers, label = "Passengers" }) => {
  const { t, language } = useBookingEditText();
  const getTypographyClass = createTypographyHelper(language);

  const passengerTypes = [
    { key: 'adult', label: t("editBooking.BookingEditPage.basicInformation.passengerType.adult") },
    { key: 'child', label: t("editBooking.BookingEditPage.basicInformation.passengerType.child") },
    { key: 'toddler', label: t("editBooking.BookingEditPage.basicInformation.passengerType.toddler") },
    { key: 'baby', label: t("editBooking.BookingEditPage.basicInformation.passengerType.baby") }
  ];

  const getTotalPassengers = () => {
    return Object.values(passengers).reduce((sum, val) => sum + val, 0);
  };

  const getPassengerDisplayText = () => {
    const parts = Object.entries(passengers)
      .filter(([_, value]) => value > 0)
      .map(([key, value]) => {
        const label = passengerTypes.find(t => t.key === key)?.label.split(' ')[0];
        return `${label}: ${value}`;
      });
    return parts.join(', ') || t("editBooking.BookingEditPage.basicInformation.passengerPlaceholder");
  };

  const handleChange = (type, increment) => {
    const newValue = increment
      ? passengers[type] + 1
      : Math.max(0, passengers[type] - 1);
    setPassengers({ ...passengers, [type]: newValue });
  };

  const renderCounter = ({ key, label }) => {
    const value = passengers[key];
    const isZero = value === 0;

    return (
      <div key={key} className="tw:flex tw:items-center tw:justify-between">
        <div className={`tw:text-[#212529] ${getTypographyClass(14)}`}>
          {label}
        </div>
        <div className="tw:flex tw:items-center tw:gap-3">
          <button
            type="button"
            onClick={() => handleChange(key, false)}
            disabled={isZero}
            className="tw:w-[32px] tw:h-[32px]"
          >
            <span className={cn(`tw:rounded-full tw:border tw:border-[#dbbe78] tw:flex tw:items-center tw:justify-center tw:w-full tw:h-full tw:transition-colors tw:text-[16px] tw:font-normal ${isZero
              ? 'tw:bg-white tw:text-[#a7a7a7] tw:opacity-40 tw:cursor-not-allowed'
              : 'tw:bg-[#f9edd3] tw:text-[#282828] hover:tw:bg-gray-50'
              }`)}>−</span>
          </button>
          <div className={`tw:w-[40px] tw:text-center tw:text-[#212529] ${getTypographyClass(14)}`}>
            {value}
          </div>
          <button
            type="button"
            onClick={() => handleChange(key, true)}
            className="tw:w-[32px] tw:h-[32px]"
          >
            <span className="tw:rounded-full tw:border tw:border-[#dbbe78] tw:flex tw:items-center tw:justify-center tw:w-full tw:h-full tw:bg-[#f9edd3] tw:text-[#282828] hover:tw:bg-[#f5e6bc] tw:transition-colors tw:text-[16px] tw:font-normal">+</span>
          </button>
        </div>
      </div>
    );
  };

  return (
    <Dropdown
      label={label}
      displayValue={getPassengerDisplayText()}
      getTypographyClass={getTypographyClass}
      placeholder={t("editBooking.BookingEditPage.basicInformation.passengerPlaceholder")}
      fieldIcon={<PaxIcon/>}
      borderColor="#e8e8e8"
    >
      <div className="tw:flex tw:flex-col tw:gap-3">
        <div className={`tw:font-bold tw:text-[#212529] ${getTypographyClass(16)}`}>
          {t("editBooking.BookingEditPage.basicInformation.passengers")}
        </div>
        <div className="tw:flex tw:flex-col tw:gap-3">
          {passengerTypes.map(renderCounter)}
        </div>
      </div>
    </Dropdown>
  );
};

export default PassengerDropdown;
